/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_ZoteroInputs */

const en_why_listening_advantage_zotero = /** @type {(inputs: Why_Listening_Advantage_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports your Zotero library`)
};

const es_why_listening_advantage_zotero = /** @type {(inputs: Why_Listening_Advantage_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa tu biblioteca de Zotero`)
};

/**
* | output |
* | --- |
* | "Imports your Zotero library" |
*
* @param {Why_Listening_Advantage_ZoteroInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_zotero = /** @type {((inputs?: Why_Listening_Advantage_ZoteroInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_ZoteroInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_zotero(inputs)
	return en_why_listening_advantage_zotero(inputs)
});